import { useState, useCallback, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReverseTransition } from '@/components/ReverseTransition';
import { TransitionContext } from './transition';

export function TransitionProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [originRect, setOriginRect] = useState<DOMRect | null>(null);

  const handleTransitionComplete = useCallback(() => {
    setIsTransitioning(false);
  }, []);

  const playTransition = useCallback((buttonRect?: DOMRect) => {
    if (buttonRect) {
      setOriginRect(buttonRect);
    }
    setIsTransitioning(true);
  }, []);

  const navigateWithTransition = useCallback((path: string, buttonRect?: DOMRect) => {
    if (buttonRect) {
      setOriginRect(buttonRect);
    }
    // Navigate immediately - the swirl overlay covers the transition
    navigate(path);
    setIsTransitioning(true);
  }, [navigate]);

  return (
    <TransitionContext.Provider value={{ playTransition, navigateWithTransition }}>
      {children}
      <ReverseTransition
        isActive={isTransitioning}
        onTransitionComplete={handleTransitionComplete}
        originRect={originRect}
      />
    </TransitionContext.Provider>
  );
}
